import React from 'react'
import { motion, AnimatePresence } from 'framer-motion/dist/framer-motion'

import './LoadingSpinner.scss'

import MainLogo from '../HomeLink/MainLogo'

const LoadingSpinner = () => {
    return (
        <AnimatePresence>
            <motion.div
                key="loading"
                className="mga-init"
                initial={{ opacity: 0 }}
                animate={{ opacity: 1 }}
                exit={{ opacity: 0 }}
                transition={{ duration: 0.5 }}
            >
                <div className="mga-init__spinner" />
                <MainLogo minimal={true} />
            </motion.div>
        </AnimatePresence>
    );
};

export default LoadingSpinner;